import React, {useCallback, useState} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import noop from 'lodash/noop'
import flow from 'lodash/flow'

import setTypingIndicator from 'modules/chat/utils/setTypingIndicator'
import Icon from 'components/Icon'
import Form, {SubmitButton} from 'modules/common/components/Form'
import InputField from './InputField'

import schema from './schema'
import styles from './styles.module.scss'

const initialValues = {message: ''}

const Compose = ({roomId, user, disabled, onAddMessage}) => {
  const [inputRef, setInputRef] = useState(null)

  const focusInputField = useCallback(() => {
    if (!inputRef) return
    inputRef.focus()
  }, [inputRef])

  const setUserIsNotTyping = useCallback(
    () => setTypingIndicator({roomId, user, isTyping: false}),
    [roomId, user]
  )

  const handleFormSubmit = useCallback(
    ({message}, {setSubmitting, resetForm}) => {
      const resetFn = flow([resetForm, setUserIsNotTyping, focusInputField])
      onAddMessage(message, resetFn)
      setSubmitting(false)
    },
    [onAddMessage, setUserIsNotTyping, focusInputField]
  )

  return (
    <Form
      className="p-1"
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleFormSubmit}>
      <div className="level is-mobile">
        <div className="level-item mr-0">
          <InputField
            innerRef={setInputRef}
            roomId={roomId}
            user={user}
            disabled={disabled}
          />
        </div>
        <div className={classNames('level-right', styles.sendBtnContainer)}>
          <div className="level">
            <SubmitButton
              name="submit"
              className="button is-white"
              disableOnInvalid>
              <span className="icon">
                <Icon icon="paper-plane" size="lg" />
              </span>
            </SubmitButton>
          </div>
        </div>
      </div>
    </Form>
  )
}

Compose.defaultProps = {
  roomId: null,
  user: null,
  disabled: false,
  onAddMessage: noop,
}

Compose.propTypes = {
  disabled: PropTypes.bool,
  onAddMessage: PropTypes.func,
  roomId: PropTypes.string,
  user: PropTypes.shape({
    uid: PropTypes.string,
    name: PropTypes.string,
  }),
}

export default Compose
